module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002sp-02.ac8c5ff6.jpg";